import { useEffect, useMemo, useState } from "react";
import { buildAffiliateAnalytics } from "../lib/affiliateAnalytics";

export default function useAffiliateAnalytics(user) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(Boolean(user));
  const [error, setError] = useState("");
  const [reloadToken, setReloadToken] = useState(0);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      if (!user?.uid) {
        setData(null);
        setLoading(false);
        setError("");
        return;
      }

      setLoading(true);
      setError("");

      try {
        const analytics = await buildAffiliateAnalytics(user.uid);
        if (!cancelled) {
          setData(analytics);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err?.message || "Failed to load affiliate analytics.");
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    load();

    return () => {
      cancelled = true;
    };
  }, [user?.uid, reloadToken]);

  return useMemo(
    () => ({
      data,
      loading,
      error,
      refresh: () => setReloadToken((value) => value + 1),
    }),
    [data, loading, error]
  );
}
